<template>
  <div>
    <!-- 左侧内容 -->
    <div class="pub_left" :style="{display:channelpubleft}">
      <div class="h1_a">
        <!-- 左侧菜单上的图片 -->
        <img :src="addleftmenusrc()" border="0" />
        <!-- 左侧菜单 -->
        <el-menu
          class="el-menu-vertical-demo el-menu"
          :unique-opened="true"
          @open="handleOpen"
          @select="handleOpen"
          @close="handleClose"
        >
          <div v-for="firstItem in leftmenusdata.children" :key="firstItem.uid">
            <el-menu-item :index="firstItem.uid+''" v-if="firstItem.children.length==0">
              <router-link
                :to="{path: '/lit/channel', query:{ uid: firstItem.uid}}"
                :title="firstItem.text"
                :class="{'or':$route.query.uid==`${firstItem.uid}`}"
              >{{firstItem.text}}</router-link>
            </el-menu-item>

            <el-submenu :index="firstItem.uid+''" v-else>
              <template slot="title">
                <span>
                  <router-link
                    :to="{path: '/lit/channel', query:{ uid: firstItem.uid}}"
                    :title="firstItem.text"
                    :class="{'or':$route.query.uid==`${firstItem.uid}`}"
                  >{{firstItem.text}}</router-link>
                </span>
              </template>
              <div v-for="subItem in firstItem.children" :key="subItem.uid">
                <el-menu-item :index="subItem.uid+''">
                  <span>▪</span>
                  {{subItem.text}}
                </el-menu-item>
              </div>
            </el-submenu>
          </div>
        </el-menu>

        <!-- 项目栏目-搜索 -->
        <div :style="{display:leftsearch}">
          <el-select
            v-model="selectcountry"
            @change="countryinput"
            filterable
            placeholder="所有国家地区"
            size="medium"
            class="elselect"
          >
            <el-option
              class="eloption"
              v-for="item in countrys"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>

          <el-select
            v-model="sector"
            @change="sectorinput"
            filterable
            placeholder="所有行业"
            size="medium"
            class="elselect"
          >
            <el-option
              class="eloption"
              v-for="item in sectors"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>

          <el-select
            v-model="amount"
            @change="amountinput"
            filterable
            placeholder="所有金额"
            size="medium"
            class="elselect"
          >
            <el-option
              class="eloption"
              v-for="item in amounts"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>

          <el-select
            v-model="type"
            @change="typeinput"
            filterable
            placeholder="所有项目类型"
            size="medium"
            class="elselect"
          >
            <el-option
              class="eloption"
              v-for="item in types"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>

          <el-button type="primary" class="ext_btn yahei" @click="projectsearch">确定</el-button>
        </div>
      </div>
    </div>

    <!-- 右侧内容 -->
    <div id="pubright" class="pub_right" :class="{pubright:currentuid=='8012'}">
      <!-- 面包屑 -->
      <div class="location1">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>
            <router-link to="/" class="el-breadcrumb__inner is-link">首页</router-link>
          </el-breadcrumb-item>
          <el-breadcrumb-item v-show="uid4 === '8000'">
            <a href="javascript:;" class="el-breadcrumb__inner is-link">推荐</a>
          </el-breadcrumb-item>
          <template v-for="(item,index) in leafpositiondata">
            <el-breadcrumb-item :key="index" v-if="index>0 && index<(leafpositiondata.length-1)">
              <a
                class="el-breadcrumb__inner is-link"
                :href="'#/lit/list?uid='+item.uid"
              >{{item.name}}</a>
            </el-breadcrumb-item>
            <el-breadcrumb-item :key="index" v-if="index==(leafpositiondata.length-1)">{{item.name}}</el-breadcrumb-item>
          </template>
        </el-breadcrumb>
      </div>

      <!-- 国别 -->
      <div class="pub_left2">
        <div class="left-gj" :style="{display:rightgj}">
          <div class="letter">
            <ul v-for="(item,index) in doccountry" :key="item.name">
              <li>
                <a
                  :id="'countryletter'+item.name"
                  @click="changecountry(item.name,index)"
                >{{item.name}}</a>
              </li>
            </ul>
            <div :style="'padding-left:'+ jgletterleft + 'px'" class="card"></div>
          </div>

          <div v-for="(item,index) in doccountry" :key="item.name">
            <div class="gq" :id="'letter_'+item.name" v-show="isShowCountry === index">
              <ul v-for="itemstate in item.states" :key="itemstate.name">
                <li class="nselect">
                  <img
                    :src="require('../../assets/imgs/flag/'+itemstate+'.png')"
                    alt
                    width="30"
                    height="20"
                  />
                  &nbsp;
                  <router-link
                    :to="{path: '/lit/channel', query:{ uid: $route.query.uid,attr:itemstate}}"
                  >{{itemstate}}</router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- 列表(带简介) -->
      <ul class="ultext summaryultext" :style="{display:listhavesummary}">
        <div class="pub_content" v-for="item in docListdata" :key="item.code">
          <ul class="list yahei mb10">
            <li>
              <a
                target="_blank"
                :title="item.title"
                :href="'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?chnid='+item.chnid+'&leafid='+item.leafid+'&docid='+item.code.substring(4,item.code.length)+'&uid='+item.uid+'&version=YDYL'"
              >
                <img
                  src="../../assets/imgs/icon10.png"
                  height="16"
                  width="12"
                  style="margin-bottom:3px;"
                  class="mr10"
                />
                <span>{{ item.title | titleellipsis}}</span>
              </a>
              <span class="date de-date">
                [
                <span>{{item.deliveddate.substring(0,10)}}</span> ]
              </span>
              <ul class="extra clearfix clear">
                <li>
                  <strong class="mr5">⊙作者:</strong>
                  {{item.author}}
                </li>
                <li>
                  <strong class="mr5">⊙来源:</strong>
                  {{item.source}}
                </li>
              </ul>
              <p class="clear" style="text-align:left">
                <span name="summary">{{ item.summary}}</span>
              </p>
              <div class="mt10">
                <span style="color:#393;float:left">⊙关键词：{{item.keywords}}</span>
              </div>
            </li>
          </ul>
        </div>
      </ul>
      <!-- 列表(不带简介) -->
      <ul class="ultext" :style="{display:listnoummary}">
        <div v-for="(item,index) in docListdata" :key="item.code">
          <li>
            <div class="sub">
              <a
                target="_blank"
                class="h_1"
                :title="item.title"
                :href="'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?chnid='+item.chnid+'&leafid='+item.leafid+'&docid='+item.code.substring(4,item.code.length)+'&uid='+item.uid+'&version=YDYL'"
              >
                <img
                  src="../../assets/imgs/icon10.png"
                  style="margin-bottom:3px;"
                  width="12"
                  height="16"
                />
                &nbsp; {{ item.title | titleellipsis}}
              </a>
            </div>
            <div class="date">
              <span>{{item.deliveddate.substring(0,10)}}</span>
            </div>
          </li>
          <li
            v-show="index>0&&(index+1)%10==0"
            style="border-bottom:1px dashed #999; margin-bottom:10px; line-height:10px; clear:both;"
          >&nbsp;</li>
        </div>
      </ul>
      <!-- 项目栏目表格 -->
      <div :style="{display:righttabletitle}">
        <table
          class="list_table_head yahei mt10"
          data-v-4a73f37f
          width="100%"
          cellpadding="0"
          cellspacing="0"
        >
          <tbody>
            <tr>
              <th width="40%">项目名称</th>
              <th width="15%">国家/地区</th>
              <th width="12%">行业</th>
              <th width="21%">金额</th>
              <th width="12%">项目类型</th>
            </tr>
          </tbody>
        </table>
      </div>

      <ul class="list_table yahei" :style="{display:righttablecontent}">
        <li v-for="item in docListdata" :key="item.code">
          <table width="100%" cellpadding="0" cellspacing="0">
            <tbody>
              <tr>
                <td width="40%">
                  &nbsp;
                  <a
                    target="_blank"
                    class="h_1"
                    :title="item.title"
                    :href="'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?chnid='+item.chnid+'&leafid='+item.leafid+'&docid='+item.code.substring(4,item.code.length)+'&uid='+item.uid+'&version=YDYL'"
                  >
                    <img
                      src="../../assets/imgs/icon10.png"
                      style="margin-bottom:3px;"
                      height="16"
                      width="12"
                    />
                    &nbsp;
                    {{ item.title}}
                  </a>
                </td>
                <td
                  width="15%"
                  v-if="item.attrIndex && item.attrIndex.length"
                >{{item.attrIndex.split(' ')[0]}}</td>
                <td width="15%" v-else></td>
                <td
                  width="12%"
                  v-if="item.attrIndex && item.attrIndex.length"
                >{{item.attrIndex.split(' ')[1]}}</td>
                <td width="12%" v-else></td>
                <td
                  width="21%"
                  v-if="item.attrIndex && item.attrIndex.length"
                >{{item.attrIndex.split(' ')[2]}}</td>
                <td width="21%" v-else></td>
                <td
                  width="21%"
                  v-if="item.attrIndex && item.attrIndex.length"
                >{{item.attrIndex.split(' ')[3]}}</td>
                <td width="21%" v-else></td>
              </tr>
            </tbody>
          </table>
        </li>
      </ul>
      <!-- 图表栏目图表 :style="{display:pictable}" -->
      <ul class="ultext" v-if="pictables">
        <li class="tubiaoli" v-for="item in docListdata" :key="item.code">
          <div class="box_border">
            <div class="box_top yahei f15">{{item.title}}</div>
            <div class="box_center">
              <a target="_blank">
                <img
                  :src="'http://www.drcnet.com.cn/www/ydyl/ImageShow.ashx?docId='+item.code.substring(4,item.code.length)+'&purposeId=2'"
                  class="img1"
                  style="width:357px;height:194px"
                />
              </a>
            </div>
            <div class="yahei miaoshu">
              <strong>来源：</strong>
              <span style="font-size:13px">{{item.summary}}</span>
            </div>
          </div>
        </li>
      </ul>
      <!-- 分页 -->
      <div style="width:650px;float:right" align="right">
        <el-pagination
          class="pagingsite"
          style="text-align:right;margin-right:1%;padding-bottom:30px;margin-top:30px;"
          background
          prev-text="上一页"
          next-text="下一页"
          layout="prev, pager, next,total,jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="pageSizes"
          :page-size="pageSize"
          :total="total"
        ></el-pagination>
      </div>
    </div>

    <!-- 园区栏目园区目录 -->
    <div class="boxright3 rgt" :style="{display:yuanqucatalog}">
      <img src="../../assets/imgs/img_yqml.png" usemap="#Map" height="21" border="0" />
      <div class="morebt2">
        <ul>
          <li v-for="(item,index) in zone" :key="item.name">
            <a
              :class="index===zoneIndex? 'tab0' : 'tab1'"
              :id="'tab'+index"
              @click="changeyuanqubg(index)"
              style="padding:0 10px"
            >{{item.name}}</a>
          </li>
        </ul>
      </div>
      <div
        v-for="(item,index) in zone"
        :key="item.name"
        :id="'divright'+index"
        class="right3"
        v-show="zoneIndex == index"
      >
        <ul class="yqlist">
          <li v-for="(itemzone,itemzoneindex) in item.zones" :key="itemzone.Id">
            <div class="parentli" @click="toggleyuanqu(index,itemzoneindex)">
              {{itemzone.name}}
              <span class="parentspan">
                <img
                  :id="'img'+index+itemzoneindex"
                  src="../../assets/imgs/yqmuluup.png"
                  border="0"
                />
              </span>
            </div>

            <ul class="sonul" :id="'sonul'+index+itemzoneindex">
              <li
                v-for="itemchildren in itemzone.children"
                :key="itemchildren.Id"
                style="margin: 5px 0px 5px 30px; width:180px;"
              >
                <!-- <router-link
                  :to="{path: '/lit/list2', query:{ uid: '8012',subuid:'801202',attr:itemchildren.Name}}"
                  
                >{{itemchildren.Name}}</router-link>-->
                <a
                  href="javascript:;;"
                  class="yq_ul_a"
                  :title="itemchildren.Name"
                  @click="yuanquClick(itemchildren.Name)"
                >{{itemchildren.Name}}</a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>

    <!-- loading -->
    <!-- <loading v-show="loading"></loading> -->
  </div>
</template>

<script>
import { api } from "@/require/api";
import loading from "@/components/loading";

export default {
  name: "channel",
  data() {
    return {
      uid: "", //url参数
      uid4: "", //4位长度的uid
      country: "",
      city: "",

      //根据uid显示不同模块
      leftmenu: "none", // 左侧导航
      leftsearch: "none", //项目栏目左侧搜索
      rightgj: "none", // 右上国家
      listhavesummary: "none", //带简介的列表
      listnoummary: "none", // 隔线列表
      righttabletitle: "none", // 右侧表格头
      righttablecontent: "none", // 右侧表格
      pictable: "none", // 右侧图表
      pictables: false,
      yuanqucatalog: "none", // 园区目录

      currentuid: "", //园区2012时显示该样式

      leafpositiondata: [], //面包屑

      docListdata: [], //右侧docs
      docListdataAll: [],
      currentPage: 1,
      pageSizes: [7, 14, 21, 28],
      pageSize: 7,
      total: 0,

      doccountry: [], //右上侧国家
      isShowCountry: 0, //这里默认为0，取到itemList数组里面第一条数据

      zone: [], //园区目录
      zoneIndex: 0, //园区目录-默认第一个tab显示
      loading: false,
      parentimg: require("../../assets/imgs/yqmuluup.png"), //园区目录切换

      jgletterleft: "", //机构上方国别区域距左距离

      errorImg01:
        'this.src="' + require("../../assets/imgs/flag/default.png") + '"',
      leftmenusdata: [], // 左侧菜单
      //项目栏目左侧搜索
      selectcountry: "",
      selectsector: "",
      selectamount: "",
      selecttype: "",
      channelpubleft: "none",
      //项目栏目左侧搜索下拉值(写死)
      countrys: [
        {
          name: "所有国家地区",
          value: "所有国家地区"
        },
        {
          name: "阿富汗",
          value: "阿富汗"
        },
        {
          name: "阿联酋",
          value: "阿联酋"
        },
        {
          name: "阿曼",
          value: "阿曼"
        },
        {
          name: "爱沙尼亚",
          value: "爱沙尼亚"
        },
        {
          name: "阿塞拜疆",
          value: "阿塞拜疆"
        },
        {
          name: "阿尔巴尼亚",
          value: "阿尔巴尼亚"
        },
        {
          name: "埃及",
          value: "埃及"
        },
        {
          name: "巴基斯坦",
          value: "巴基斯坦"
        },
        {
          name: "不丹",
          value: "不丹"
        },
        {
          name: "巴林",
          value: "巴林"
        },
        {
          name: "巴勒斯坦",
          value: "巴勒斯坦"
        },
        {
          name: "白俄罗斯",
          value: "白俄罗斯"
        },
        {
          name: "波兰",
          value: "波兰"
        },
        {
          name: "保加利亚",
          value: "保加利亚"
        },
        {
          name: "波黑",
          value: "波黑"
        },
        {
          name: "东帝汶",
          value: "东帝汶"
        },
        {
          name: "俄罗斯",
          value: "俄罗斯"
        },
        {
          name: "菲律宾",
          value: "菲律宾"
        },
        {
          name: "格鲁吉亚",
          value: "格鲁吉亚"
        },
        {
          name: "哈萨克斯坦",
          value: "哈萨克斯坦"
        },
        {
          name: "黑山",
          value: "黑山"
        },

        {
          name: "吉尔吉斯斯坦",
          value: "吉尔吉斯斯坦"
        },

        {
          name: "捷克",
          value: "捷克"
        },
        {
          name: "科威特",
          value: "科威特"
        },

        {
          name: "卡塔尔",
          value: "卡塔尔"
        },

        {
          name: "克罗地亚",
          value: "克罗地亚"
        },

        {
          name: "老挝",
          value: "老挝"
        },

        {
          name: "黎巴嫩",
          value: "黎巴嫩"
        },
        {
          name: "摩洛哥",
          value: "摩洛哥"
        },
        {
          name: "罗马尼亚",
          value: "罗马尼亚"
        },

        {
          name: "拉脱维亚",
          value: "拉脱维亚"
        },

        {
          name: "立陶宛",
          value: "立陶宛"
        },

        {
          name: "蒙古",
          value: "蒙古"
        },

        {
          name: "马来西亚",
          value: "马来西亚"
        },
        {
          name: "缅甸",
          value: "缅甸"
        },
        {
          name: "新西兰",
          value: "新西兰"
        },
        {
          name: "孟加拉国",
          value: "孟加拉国"
        },

        {
          name: "马尔代夫",
          value: "马尔代夫"
        },

        {
          name: "摩尔多瓦",
          value: "摩尔多瓦"
        },

        {
          name: "马其顿",
          value: "马其顿"
        },

        {
          name: "尼泊尔",
          value: "尼泊尔"
        },

        {
          name: "斯里兰卡",
          value: "斯里兰卡"
        },

        {
          name: "沙特",
          value: "沙特"
        },

        {
          name: "泰国",
          value: "泰国"
        },

        {
          name: "斯洛伐克",
          value: "斯洛伐克"
        },

        {
          name: "斯洛文尼亚",
          value: "斯洛文尼亚"
        },

        {
          name: "塞尔维亚",
          value: "塞尔维亚"
        },

        {
          name: "土库曼斯坦",
          value: "土库曼斯坦"
        },

        {
          name: "塔吉克斯坦",
          value: "塔吉克斯坦"
        },

        {
          name: "土耳其",
          value: "土耳其"
        },

        {
          name: "乌兹别克斯坦",
          value: "乌兹别克斯坦"
        },

        {
          name: "乌克兰",
          value: "乌克兰"
        },
        {
          name: "希腊",
          value: "希腊"
        },

        {
          name: "卢森堡",
          value: "卢森堡"
        },
        {
          name: "意大利",
          value: "意大利"
        },
        {
          name: "塞浦路斯",
          value: "塞浦路斯"
        },
        {
          name: "文莱",
          value: "文莱"
        },

        {
          name: "新加坡",
          value: "新加坡"
        },

        {
          name: "叙利亚",
          value: "叙利亚"
        },

        {
          name: "匈牙利",
          value: "匈牙利"
        },

        {
          name: "印度尼西亚",
          value: "印度尼西亚"
        },

        {
          name: "越南",
          value: "越南"
        },

        {
          name: "印度",
          value: "印度"
        },

        {
          name: "以色列",
          value: "以色列"
        },

        {
          name: "伊朗",
          value: "伊朗"
        },

        {
          name: "伊拉克",
          value: "伊拉克"
        },

        {
          name: "约旦",
          value: "约旦"
        },

        {
          name: "也门",
          value: "也门"
        },

        {
          name: "索马里",
          value: "索马里"
        },
        {
          name: "科特迪瓦",
          value: "科特迪瓦"
        },
        {
          name: "塞拉利昂",
          value: "塞拉利昂"
        },
        {
          name: "喀麦隆",
          value: "喀麦隆"
        },
        {
          name: "南苏丹",
          value: "南苏丹"
        },
        {
          name: "塞舌尔",
          value: "塞舌尔"
        },
        {
          name: "几内亚",
          value: "几内亚"
        },
        {
          name: "加纳",
          value: "加纳"
        },
        {
          name: "赞比亚",
          value: "赞比亚"
        },
        {
          name: "莫桑比克",
          value: "莫桑比克"
        },
        {
          name: "加蓬",
          value: "加蓬"
        },
        {
          name: "纳米比亚",
          value: "纳米比亚"
        },
        {
          name: "毛里塔尼亚",
          value: "毛里塔尼亚"
        },
        {
          name: "安哥拉",
          value: "安哥拉"
        },
        {
          name: "吉布提",
          value: "吉布提"
        },
        {
          name: "埃塞俄比亚",
          value: "埃塞俄比亚"
        },
        {
          name: "肯尼亚",
          value: "肯尼亚"
        },
        {
          name: "尼日利亚",
          value: "尼日利亚"
        },
        {
          name: "乍得",
          value: "乍得"
        },
        {
          name: "刚果布",
          value: "刚果布"
        },
        {
          name: "津巴布韦",
          value: "津巴布韦"
        },
        {
          name: "阿尔及利亚",
          value: "阿尔及利亚"
        },
        {
          name: "坦桑尼亚",
          value: "坦桑尼亚"
        },
        {
          name: "布隆迪",
          value: "布隆迪"
        },
        {
          name: "佛得角",
          value: "佛得角"
        },
        {
          name: "乌干达",
          value: "乌干达"
        },
        {
          name: "冈比亚",
          value: "冈比亚"
        },
        {
          name: "多哥",
          value: "多哥"
        },
        {
          name: "南非",
          value: "南非"
        },
        {
          name: "苏丹",
          value: "苏丹"
        },
        {
          name: "马达加斯加",
          value: "马达加斯加"
        },
        {
          name: "突尼斯",
          value: "突尼斯"
        },
        {
          name: "利比亚",
          value: "利比亚"
        },
        {
          name: "塞内加尔",
          value: "塞内加尔"
        },
        {
          name: "卢旺达",
          value: "卢旺达"
        },
        {
          name: "赤道几内亚",
          value: "赤道几内亚"
        },
        {
          name: "利比里亚",
          value: "利比里亚"
        },
        {
          name: "安提瓜和巴布达",
          value: "安提瓜和巴布达"
        },
        {
          name: "巴拿马",
          value: "巴拿马"
        },
        {
          name: "特立尼达和多巴哥",
          value: "特立尼达和多巴哥"
        },
        {
          name: "玻利维亚",
          value: "玻利维亚"
        },
        {
          name: "哥斯达黎加",
          value: "哥斯达黎加"
        },
        {
          name: "乌拉圭",
          value: "乌拉圭"
        },
        {
          name: "圭亚那",
          value: "圭亚那"
        },
        {
          name: "苏里南",
          value: "苏里南"
        },
        {
          name: "委内瑞拉",
          value: "委内瑞拉"
        },
        {
          name: "秘鲁",
          value: "秘鲁"
        },
        {
          name: "厄瓜多尔",
          value: "厄瓜多尔"
        },
        {
          name: "巴布亚新几内亚",
          value: "巴布亚新几内亚"
        },
        {
          name: "多米尼克",
          value: "多米尼克"
        },
        {
          name: "纽埃",
          value: "纽埃"
        },
        {
          name: "格林纳达",
          value: "格林纳达"
        },
        {
          name: "牙买加",
          value: "牙买加"
        },
        {
          name: "巴巴多斯",
          value: "巴巴多斯"
        },
        {
          name: "亚美尼亚",
          value: "亚美尼亚"
        },
        {
          name: "奥地利",
          value: "奥地利"
        },
        {
          name: "柬埔寨",
          value: "柬埔寨"
        }
      ],
      selectcountry: "",
      sectors: [
        { name: "所有行业", value: "所有行业" },
        { name: "农业", value: "农业" },
        { name: "能源矿产", value: "能源矿产" },
        { name: "信息通信", value: "信息通信" },
        { name: "基础设施", value: "基础设施" },
        { name: "制造业", value: "制造业" },
        { name: "服务业", value: "服务业" }
      ],
      sector: "",
      amounts: [
        { name: "所有金额", value: "所有金额" },
        { name: "0-1000万美元", value: "0-1000万美元" },
        { name: "1000万—5000万美元", value: "1000万—5000万美元" },
        { name: "5000万-1亿美元", value: "5000万-1亿美元" },
        { name: "1亿美元以上", value: "1亿美元以上" }
      ],
      amount: "",
      types: [
        { name: "所有项目类型", value: "所有项目类型" },
        { name: "股权投资", value: "股权投资" },
        { name: "绿地投资", value: "绿地投资" },
        { name: "融资租赁", value: "融资租赁" },
        { name: "债权投资", value: "债权投资" },
        { name: "其它投资", value: "其它投资" }
      ],
      type: "",
      yuanquTabSubuid: "",
      yuanquName: ""
    };
  },
  filters: {
    //文章标题截取
    titleellipsis(value) {
      if (!value) return "";
      if (value.length > 35) {
        return value.slice(0, 35) + "...";
      }
      return value;
    },
    projecttitleellipsis(value) {
      if (!value) return "";
      if (value.length > 18) {
        return value.slice(0, 18) + "...";
      }
      return value;
    },
    //文章简介截取
    summaryellipsis(value) {
      if (!value) return "";

      if (value.length > 110) {
        return value.slice(0, 110) + "...";
      }
      return value;
    }
  },
  components: {
    loading
  },
  created() {
    this.uid = this.$route.query.uid;
    this.uid4 = this.uid.toString().substring(0, 4);
    // console.log(this.uid4, "this.uid4");
    this.country = this.$route.query.attr;
    this.city = this.$route.query.city;
    // 添加“推荐”栏目，特殊处理
    if (this.uid4.indexOf("8000") !== -1) {
      this.loaddocsTJ();
      this.listhavesummary = "block";
    } else {
      // 非“推荐”栏目，特殊处理
      if (this.uid4.indexOf("8008") !== -1) {
        this.channelpubleft = "block";
        this.leftsearch = "block";
        this.loadLeftmenus();
      } else {
        this.channelpubleft = "none";
        this.leftsearch = "none";
      }

      if (this.uid4.indexOf("8012") !== -1) {
        this.currentuid = "8012";
        this.loadzone();
      } else {
        this.currentuid = this.uid4;
      }

      if (this.uid4.indexOf("8011") !== -1) {
        this.loadcountry();
      }
      if (this.uid4.indexOf("8000") !== -1) {
      }

      this.showModular(this.uid);
      this.loadleafPosition();

      this.loaddocs();

      this.addleftmenusrc();
    }
  },
  methods: {
    // 添加“推荐”栏目
    async loaddocsTJ() {
      //8b0806eb2bb3468084a0c7707e7804d5/f0e06248151c1b7634138768862d880f5f00187f70
      let logguid = document.cookie.replace(
        /(?:(?:^|.*;\s*)8b0806eb2bb3468084a0c7707e7804d5\s*\=\s*([^;]*).*$)|^.*$/,
        "$1"
      );
      const { code, data } = await api.get("HomePageController/getRecommend", {
        mark: "ydyl",
        rec_num: 20,
        guid: logguid
      });
      if (code === 0) {
        this.total = 20;
        this.docListdataAll = data;
        this.currentPage = 1;
        this.pageSize = 12;
        this.docListdata = this.docListdataAll.slice(0, 12);
      }
    },
    yuanquClick(value) {
      this.yuanquName = value;
      this.loadyqmodel().then(() => {
        this.$router.push({
          path: "/lit/list2",
          query: {
            uid: "8012",
            subuid: this.yuanquTabSubuid,
            attr: this.yuanquName
          }
        });
      });
    },
    //园区基本信息
    async loadyqmodel() {
      const { code, data } = await api.get("/documentController/getZoneInfo", {
        yuanquName: this.yuanquName
      });
      if (code === 0) {
        let tabData = 0;
        for (let i = 0; i < data.yuanquChannel.length; i++) {
          if (data.yuanquChannel[i].uid === "801202") {
            tabData = tabData + 1;
          }
        }
        if (tabData === 0) {
          this.yuanquTabSubuid = data.yuanquChannel[0].uid;
        } else if (tabData === 1) {
          this.yuanquTabSubuid = "801202";
        }
      }
    },
    //园区目录：index1是tab的num，index2是各个li的num
    toggleyuanqu(index1, index2) {
      $("#sonul" + index1 + index2).toggle();

      if ($("#sonul" + index1 + index2).css("display") == "block") {
        $("#img" + index1 + index2).attr(
          "src",
          require("../../assets/imgs/yqmuludown.png")
        );
      } else {
        $("#img" + index1 + index2).attr(
          "src",
          require("../../assets/imgs/yqmuluup.png")
        );
      }
    },
    addleftmenusrc() {
      try {
        let yqinfoimgs = require("../../assets/imgs/UID/" + this.uid4 + ".gif");
        return yqinfoimgs;
      } catch (err) {
        let yqinfeorrorimg = require("../../assets/imgs/UID/default.gif");
        return yqinfeorrorimg;
      }
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
    // 左侧菜单接口
    async loadLeftmenus() {
      const { code, data } = await api.get(
        "/documentController/getWebChannel",
        {
          uid: this.uid4
        }
      );
      if (code === 0) {
        this.leftmenusdata = data;
      }
    },
    //项目栏目-搜索-改变下拉值
    countryinput(value) {
      this.selectcountry = value;
    },
    sectorinput(value) {
      this.selectsector = value;
    },
    amountinput(value) {
      this.selectamount = value;
    },
    typeinput(value) {
      this.selecttype = value;
    },
    //项目栏目-搜索-确定
    async projectsearch() {
      let searchparam = "";
      if (this.selectcountry != "" && this.selectcountry != "所有国家地区") {
        searchparam += `${this.selectcountry},`;
      }
      if (this.selectsector != "" && this.selectsector != "所有行业") {
        searchparam += `${this.selectsector},`;
      }
      if (this.selectamount != "" && this.selectamount != "所有金额") {
        searchparam += `${this.selectamount},`;
      }
      if (this.selecttype != "" && this.selecttype != "所有项目类型") {
        searchparam += `${this.selecttype},`;
      }
      searchparam = searchparam.substring(0, searchparam.lastIndexOf(","));

      const { code, data } = await api.get(
        "/documentController/getPageChannelDocumentsByUId",
        {
          uid: this.uid,
          curPage: this.currentPage,
          pageSize: this.pageSize,
          attr: searchparam
        }
      );
      if (code === 0) {
        this.total = data.totlalCount;
        this.docListdata = data.data;
      }
    },
    //根据uid显示不同模块
    showModular(uid4) {
      //根据uid显示不同模块
      this.leftmenu = "none"; // 左侧导航
      this.rightgj = "none"; // 右上国家
      this.listhavesummary = "none"; //带简介的列表
      this.listnoummary = "none"; // 隔线列表
      this.righttabletitle = "none"; // 右侧表格头
      this.righttablecontent = "none"; // 右侧表格
      this.pictable = "none"; // 右侧图表
      this.pictables = false;
      this.yuanqucatalog = "none"; // 园区目录

      if (uid4 == "8003") {
        this.pageSize = 7;
        (this.pageSizes = [7, 14, 21, 28]), (this.leftmenu = "none");
        this.listhavesummary = "block";
      } else if (
        uid4.indexOf("8004") !== -1 ||
        uid4.indexOf("8005") !== -1 ||
        uid4.indexOf("8016") !== -1 ||
        uid4.indexOf("8006") !== -1
      ) {
        this.pageSize = 7;
        this.pageSizes = [7, 14, 21, 28];
        this.listhavesummary = "block";
      } else if (
        uid4.indexOf("8002") !== -1 ||
        uid4.indexOf("8007") !== -1 ||
        uid4.indexOf("8009") !== -1 ||
        uid4.indexOf("8010") !== -1
      ) {
        this.pageSize = 35;
        (this.pageSizes = [35, 70, 105, 140]), (this.listnoummary = "block");
      } else if (uid4.indexOf("8011") !== -1) {
        this.pageSize = 30;
        (this.pageSizes = [30, 60, 90, 120]), (this.rightgj = "block");
        this.listnoummary = "block";
      } else if (uid4.indexOf("8008") !== -1) {
        this.pageSize = 19;
        (this.pageSizes = [19, 38, 57, 76]), (this.righttabletitle = "block");
        this.righttablecontent = "block";
      } else if (uid4.indexOf("8001") !== -1) {
        this.pageSize = 8;
        (this.pageSizes = [8, 16, 24, 32]), (this.pictables = true);
      } else if (uid4.indexOf("8012") !== -1) {
        this.currentuid4 = "8012";
        this.pageSize = 7;
        (this.pageSizes = [5, 10, 15, 20]), (this.listhavesummary = "block");
        this.yuanqucatalog = "block";
      }
      // 初始化当前页
      this.currentPage = 1;

      this.uid = this.$route.query.uid;
      this.uid4 = this.uid.toString().substring(0, 4);
      this.country = this.$route.query.attr;
      this.city = this.$route.query.city;

      this.loadleafPosition();

      // this.loaddocs();
    },
    // 面包屑接口
    async loadleafPosition() {
      const { code, data } = await api.get("/documentController/getLocation", {
        uid: this.uid
      });
      if (code === 0) {
        this.leafpositiondata = data;
      }
    },
    //获取文章列表
    async loaddocs() {
      this.loading = true;
      const { code, data } = await api.get(
        "/documentController/getPageChannelDocumentsByUId",
        {
          uid: this.uid,
          attr: this.country,
          curPage: this.currentPage,
          pageSize: this.pageSize
        }
      );
      if (code === 0) {
        this.total = data.totlalCount;
        this.docListdata = data.data;

        // this.loading = false;
      }
    },
    // 分页-当前页
    handleCurrentChange(currentPageVal) {
      this.currentPage = currentPageVal;
      if (this.uid4.indexOf("8000") !== -1) {
        if (this.currentPage === 1) {
          this.docListdata = this.docListdataAll.slice(0, 12);
        } else {
          this.docListdata = this.docListdataAll.slice(12);
        }
      } else {
        this.loaddocs();
      }
    },
    //分页-pagesize
    handleSizeChange(pageSizeVal) {
      this.pageSize = pageSizeVal;
      this.loaddocs();
    },
    //机构栏目-国别列表
    async loadcountry() {
      const { code, data } = await api.get("/documentController/getStateList");
      if (code === 0) {
        this.doccountry = data;
      }
    },
    //机构栏目-国别切换
    changecountry(letter, index) {
      if (this.isShowCountry === index) {
        this.isShowCountry = -1; //在这里就将它赋值为-1  由于：-1 !=  index 所以其他内容隐藏 ，被点击的则打开
      } else {
        this.isShowCountry = index; //这里是把index赋值给isShow，isShow=index则显示
      }

      let letterjga = document.getElementById("countryletter" + letter);
      this.jgletterleft = letterjga.getBoundingClientRect().left;
      this.jgletterleft = 65 + index * 75.5;
    },
    //园区列表
    async loadzone() {
      // const { code, data } = await api.get("/documentController/getZoneList");
      const { code, data } = await api.get(
        "/documentController/getZoneListByProv"
      );
      if (code === 0) {
        this.zone = data;
      }
    },
    //园区目录改变tab样式
    changeyuanqubg(index) {
      this.zoneIndex = index;
    }
  },
  watch: {
    $route: function() {
      this.uid = this.$route.query.uid;
      this.uid4 = this.uid.toString().substring(0, 4);
      this.showModular(this.uid4);
      // console.log(this.uid4, "this.uid4");
      // 添加“推荐”栏目，特殊处理
      if (this.uid4.indexOf("8000") !== -1) {
        this.loaddocsTJ();
        this.listhavesummary = "block";
      } else {
        // 非“推荐”栏目，特殊处理
        if (this.uid4.indexOf("8008") !== -1) {
          this.channelpubleft = "block";
          this.leftsearch = "block";
          this.loadLeftmenus();
        } else {
          this.channelpubleft = "none";
          this.leftsearch = "none";
        }

        if (this.uid4.indexOf("8012") !== -1) {
          this.currentuid = "8012";
          this.loadzone();
        } else {
          this.currentuid = this.uid4;
        }

        if (this.uid4.indexOf("8011") !== -1) {
          this.loadcountry();
        }

        this.loaddocs();

        this.addleftmenusrc();

        //改变左侧栏目时清空“项目”栏目左侧搜索项
        this.selectcountry = "";
        this.sector = "";
        this.amount = "";
        this.type = "";
      }
    }
  }
};
</script>
<style lang='less' scoped>
// css.css
/* CSS Document */
/deep/img {
  border: 0;
  vertical-align: middle;
  display: inline-block;
}
a {
  text-decoration: none;
}
a:link {
  text-decoration: none;
}
a:visited {
  text-decoration: none;
}
a:hover {
  text-decoration: underline;
}
/* font */
.fB {
  font-weight: bold;
}
.red1 {
  color: #c81623;
}
.yellow1 {
  color: #ff0;
}
.h_1 {
  color: #333;
}

/* float */
.clear {
  clear: both;
  display: block;
}
.f12 {
  font-size: 12px;
}
.f15 {
  font-size: 15px;
}
.f19 {
  font-size: 19px;
}
/* margin */
.mb10 {
  margin-bottom: 10px;
}
.mt10 {
  margin-top: 10px;
}
.pt10 {
  padding-top: 10px;
}
.container {
  width: 1200px;
  margin: 0 auto;
}
.tright {
  text-align: right;
}

.lft {
  float: left;
}
.rgt {
  float: right;
  display: inline;
}
.clear {
  clear: both;
  display: block;
}

#substation .header_bottom .nav .subnav {
  margin: 0 16px;
}
/*-------main------------*/
.mianbox {
  background-color: #fff;
  margin-top: 10px;
  padding-top: 2px;
}
.hot {
  margin: 10px 10px 0px;
  width: 1210px;
  height: 358px;
}
.slideBox {
  position: relative;
  float: left;
  margin: 10px 0;
  overflow: hidden;
  width: 661px;
  height: 338px;
  font-size: 0;
}
.slideBox .bd {
  height: 100%;
}
.slideBox .txtbg {
  width: 100%;
  height: 40px;
  left: 0;
  bottom: 0;
  background: #000;
  color: white;
  position: absolute;
  filter: Alpha(opacity=70);
  -moz-opacity: 0.7;
  opacity: 0.7;
  z-index: 99;
}
.slideBox .num {
  height: 10px;
  position: absolute;
  z-index: 9999;
  bottom: 16px;
  right: 0px;
}
.slideBox .num .on {
  background: #0b7ed1;
}
.slideBox .num span {
  background: #999;
  display: block;
  width: 20px;
  height: 11px;
  margin-right: 12px;
  cursor: pointer;
  float: left;
}
.slideBox h2 {
  position: absolute;
  width: 661px;
  height: 40px;
  line-height: 39px;
  font-size: 16px;
  color: #fff;
  bottom: 0;
  padding: 0 85px 0 15px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: left;
  z-index: 100;
}

.hot_spot {
  position: relative;
  float: right;
  width: 520px;
  height: 338px;
  padding: 0px 10px 0px 10px;
  border-bottom: #ccc 1px solid;
  border-right: #ccc 1px solid;
  background: url(../../assets/imgs/tu2.gif) right bottom no-repeat;
  margin-top: 10px;
}
.hot_spot .img1 {
  margin-bottom: 10px;
}
.hot_spot h3 {
  line-height: 35px;
  font-size: 18px;
  font-family: "微软雅黑", "Microsoft YaHei";
  font-weight: bold;
}
.hot_spot ul li {
  line-height: 35px;
}
.hot_spot ul li a {
  color: #333;
  text-decoration: none;
}
.hot_spot ul li a:hover {
  color: #c00;
}
.hot_spot ul li img {
  z-index: -1;
}
.hot_spot .briefly {
  color: #888;
  font-size: 13px;
  white-space: normal;
  padding-left: 5px;
  padding-top: 5px;
  line-height: 25px;
  margin: 0 0 2px;
  text-indent: 2em;
  border-bottom: 1px dashed #ccc;
  height: 80px;
}

/* -------left-----------*/
.container_left {
  float: left;
  width: 824px;
}
.list_report {
  width: 824px;
  padding: 5px 10px 0px;
}
.list_main {
  width: 400px;
  padding: 10px 0px;
}
.list_report .lest_a {
  border: #ccc solid 1px;
}
.list_content {
  margin-top: 10px;
}
.list_content .title {
  margin-bottom: 6px;
  height: 103px;
}
.list_content .title .img1 {
  border: #ccc 1px solid;
  padding: 1px;
  float: left;
  margin-right: 10px;
  width: 119px;
  height: 74px;
}
.list_content .title h3 {
  padding-bottom: 5px;
  border-bottom: 1px dashed #ccc;
  font-size: 14px;
  color: #9b1111;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 44px;
  *height: 50px;
  *float: right;
  *width: 265px;
}
.list_content .title h3 a {
  color: #115bac;
}
.list_content .title h3 a:hover {
  color: #c00;
  text-decoration: none;
}
.list_content .title .briefly {
  padding-left: 10px;
  font-size: 12px;
  color: #888;
  margin-top: 5px;
}

.list_content .list_article li {
  list-style-type: none;
}
.list_content .list_article li a {
  color: #333;
  height: 33px;
  line-height: 33px;
  text-decoration: none;
}
.list_content .list_article li a:hover {
  color: #c00;
}
/*----------right-----------*/
.container_right {
  width: 370px;
  float: right;
  margin-right: 10px;
  margin-top: 0px;
}
.container_right .gb {
  border-top: none;
  border: #e7e7e7 1px solid;
  border-top: none;
  height: 185px;
}
.container_right .gb .zm {
  margin-top: 10px;
}
.container_right .gb .zm ul li {
  float: left;
  line-height: 30px;
  padding-left: 5px;
  text-align: center;
  margin-bottom: 10px;
}
.container_right .gb .zm .region1 {
  display: block;
  background: #cd3333;
  font-size: 18px;
  width: 83px;
  color: #fff;
}
.container_right .gb .zm .region {
  display: block;
  font-size: 18px;
  width: 83px;
  color: #333;
  background: #e6e6e6;
  text-decoration: none;
  display: block;
}

.countries_a {
  width: 350px;
  margin: 0 10px;
}
.countries_a a {
  right: 10px;
  padding-right: 15px;
  color: #333;
  line-height: 27px;
  text-decoration: none;
}
.countries_a a:hover {
  color: #c00;
}

.container_right .gh {
  border-top: none;
  border: #e7e7e7 1px solid;
  border-top: none;
}
.title_a {
  margin: 10px 0;
}
.title_a ul li {
  padding-left: 10px;
  line-height: 30px;
}
.title_a ul li a {
  color: #333;
  text-decoration: none;
}
.title_a ul li a:hover {
  color: #c00;
}
.title_a h3 {
  height: 30px;
  line-height: 30px;
  background-color: #e6e6e6;
  padding-left: 10px;
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 10px;
}
.title_a .more_b {
  text-align: right;
  margin-right: 10px;
}

.demo1 {
  float: left;
  clear: both;
  width: 1220px;
  height: 260px;
  overflow: hidden;
  background-color: #fff;
  margin: 10px auto;
  border: 1px #e7e7e7 solid;
}
.inside {
  position: relative;
  top: 110px;
  left: 0;
  height: 150px;
  margin-top: -75px;
  width: 1220px;
}
.demo1 .insidetext {
  position: relative;
  top: 10%;
  left: 0;
  width: 1220px;
}
.demo1 .insidetext .text {
  text-align: center;
  width: 130px;
}

.demo1 .num {
  height: 10px;
  z-index: 9999;
  width: 200px;
  margin-top: 160px;
  margin-left: 1080px;
}
.demo1 .num .on {
  background: #0b7ed1;
}
.demo1 .num span {
  background: #999;
  display: block;
  width: 20px;
  height: 11px;
  margin-right: 12px;
  cursor: pointer;
  float: left;
}

.demo1 .inside .inside_t1 {
  z-index: 1;
  width: 135px;
  height: 135px;
  display: block;
}
.demo1 .inside .inside_t2 {
  top: -20px;
  z-index: 10;
  width: 190px;
  height: 190px;
  display: block;
  margin-left: -30px;
  margin-top: 0px;
}
.demo1 a {
  display: block;
  position: absolute;
  width: 130px;
  height: 130px;
  overflow: hidden;
  border: 3px solid #fff;
  -moz-border-radius: 150px;
  -webkit-border-radius: 150px;
  border-radius: 150px;
}
.scroller .active {
  z-index: 5 !important;
}

.demo1 .inside .inside_tt {
  text-align: center;
  position: absolute;
  width: 135px;
}
.demo1 .inside .inside_tt .zz {
  position: relative;
}

/*测试国家小图变大图*/
.demo2 li {
  float: left;
  text-align: center;
  cursor: pointer;
  z-index: 0;
  position: relative;
  margin: 0px -20px 10px 0px;
  width: 130px;
  height: 130px;
}
.demo2 li .r {
  margin-right: 0;
}
.demo2 li .in img {
  *width: 130px;
  *height: auto;
}
.demo2 li .in {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
  width: 130px;
}
.demo2 li .in .imgdiv {
  display: block;
  width: 130px;
  height: 130px;
  margin: 0 auto;
  margin-top: 4px;
  overflow: hidden;
}
.demo2 li span {
  display: block;
  text-align: center;
  height: 36px;
  padding: 8px 3px 0 3px;
  font-size: 14px;
  line-height: 20px;
  color: #666;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.demo2 li .b1 {
  display: block;
  color: #333;
}
.demo2 li .b2 {
  display: block;
  color: #0065b9;
  font-weight: bold;
}
.demo2 li.pic .original {
  display: none;
  padding: 5px;
  padding-bottom: 0;
  position: absolute;
  text-align: center;
  left: -16px;
  top: -59px;
}
.demo2 li.pic .original .imga {
  display: block;
}
.demo2 li .original img {
  *height: 130px;
  *width: auto;
}
.demo2 li .original span {
  height: 36px;
  padding-top: 0;
}
.demo2 li .original b {
  line-height: 36px;
}
.demo2 li.on {
  z-index: 99;
}
.demo2 li.on .original {
  display: block;
  z-index: 100;
}

/* float */
.slide_country {
  position: relative;
  z-index: 0;
  width: 1220px;
  background: #fff;
  height: 278px;
  overflow: hidden;
}
.slide_country .box {
  overflow: hidden;
  position: relative;
  width: 1220px;
  height: 278px;
}

.slide_country .btn {
  overflow: hidden;
  position: absolute;
  bottom: 25px;
  right: 15px;
  z-index: 10;
}
.slide_country .btn li {
  float: left;
  width: 20px;
  height: 15px;
  margin: 0 0 0 10px;
  font-size: 12px;
  font-family: Arial, Helvetica, sans-serif;
  background: #525252;
  color: #fff;
  line-height: 18px;
  border: 1px solid #434343;
  text-align: center;
  cursor: pointer;
}
.slide_country .btn .selected {
  background: #0b7ed1;
  border-color: #0b7ed1;
}
// .slide_country .minus,.slide_country .plus{position:absolute;top:110px; width:30px; height:75px; background:url(../../assets/imgs/slider_bn_bg.png) no-repeat 0 0; text-align:center;cursor:pointer;}
.slide_country .minus,
.slide_country .plus {
  position: absolute;
  top: 110px;
  width: 30px;
  height: 75px;
  text-align: center;
  cursor: pointer;
}
.slide_country .minus {
  left: 0;
  background-position: 0 0;
}
.slide_country .plus {
  right: 0;
  background-position: 0px -75px;
}
.slide_country .minus:hover {
  background-position: -30px 0px;
}
.slide_country .plus:hover {
  background-position: -30px -75px;
}

.container_right .zj {
  border-top: none;
  border: #e7e7e7 1px solid;
  border-top: none;
  padding-bottom: 10px;
}
.container_right .zj img {
  margin-bottom: 10px;
}
.container_right .zj .zt_imglist {
  height: 42px;
  margin-top: 12px;
}
.container_right .zj .zt_imglist strong {
  background-color: #cd3333;
  color: #fff;
  font-size: 15px;
  float: left;
  width: 58px;
  height: 31px;
  line-height: 31px;
  text-align: center;
  margin-left: 15px;
}
.container_right .zj .zt_imglist a {
  display: block;
  background: transparent url("../../assets/imgs/line2.jpg") no-repeat scroll 0%
    0%;
  width: 260px;
  height: 31px;
  line-height: 31px;
  float: left;
  padding-left: 20px;
  color: #333;
  float: right;
}
.container_right .zj .zt_imglist a:hover {
  color: #cd3333;
  text-decoration: none;
}

.container_right .dsj {
  border-top: none;
  border: #e7e7e7 1px solid;
  border-top: none;
  padding-bottom: 10px;
}
.textdricon {
  background: url(../../assets/imgs/line1.jpg) repeat-y 102px top;
  padding-bottom: 20px;
}
.textdricon strong {
  display: block;
  width: 100px;
  float: left;
  background: url(../../assets/imgs/icon2.png) no-repeat right center;
  height: 30px;
  line-height: 30px;
  color: #500d08;
  font-size: 13px;
}
.textdricon .point1 {
  background: url(../../assets/imgs/icon2.png) no-repeat right center;
}
.textdricon .point2 {
  background: url(../../assets/imgs/icon3.png) no-repeat right center;
}
.textdricon .point3 {
  background: url(../../assets/imgs/icon4.png) no-repeat right center;
}
.textdricon .point4 {
  background: url(../../assets/imgs/icon5.png) no-repeat right center;
}
.textdricon .point5 {
  background: url(../../assets/imgs/icon6.png) no-repeat right center;
}
.textdricon .point6 {
  background: url(../../assets/imgs/icon7.png) no-repeat right center;
}
.textdricon .point7 {
  background: url(../../assets/imgs/icon8.png) no-repeat right center;
}
.textdricon .point8 {
  background: url(../../assets/imgs/icon9.png) no-repeat right center;
}
.textdricon a {
  width: 220px;
  padding: 5px;
  color: #500d08;
}
.textdricon li {
  padding-left: 10px;
  margin-top: 20px;
  height: 70px;
}
.textdricon .mCon_Cutbtn {
  background: #ecf6ff;
  border-bottom: 2px #0065b8 solid;
}

.jg_box .jg_a {
  width: 823px;
  float: left;
  margin-top: 20px;
}
.jg_box .jg_a li {
  float: left;
  background: #fff none repeat scroll 0% 0%;
  border: 1px solid #e4e4e4;
  display: inline-block;
  height: 108px;
  margin-bottom: 14px;
  text-align: center;
  width: 120px;
  margin-left: 7px;
  *margin-left: 13px;
}
.jg_box .jg_a li a {
  background: transparent url(../../assets/imgs/icon1.png) no-repeat scroll 0px
    0px;
  display: inline-block;
  height: 50px;
  margin-top: 17px;
  overflow: hidden;
  width: 50px;
}
.jg_box .jg_a li p {
  font-weight: bold;
  font-size: 13px;
}
.jg_box .jg_a li .c1 {
  background-position: 0px 0px;
}
.jg_box .jg_a li .c2 {
  background-position: 0px -59px;
}
.jg_box .jg_a li .c3 {
  background-position: 0px -118px;
}
.jg_box .jg_a li .c4 {
  background-position: 0px -177px;
}
.jg_box .jg_a li .c5 {
  background-position: 0px -236px;
}
.jg_box .jg_a li .c6 {
  background-position: 0px -295px;
}
.jg_box .jg_a li .c7 {
  background-position: 0px -354px;
}
.jg_box .jg_a li .c8 {
  background-position: 0px -413px;
}
.jg_box .jg_a li .c9 {
  background-position: 0px -472px;
}
.jg_box .jg_a li .c1:hover {
  background-position: -73px -0px;
}
.jg_box .jg_a li .c2:hover {
  background-position: -73px -59px;
}
.jg_box .jg_a li .c3:hover {
  background-position: -73px -118px;
}
.jg_box .jg_a li .c4:hover {
  background-position: -73px -177px;
}
.jg_box .jg_a li .c5:hover {
  background-position: -73px -236px;
}
.jg_box .jg_a li .c6:hover {
  background-position: -73px -295px;
}
.jg_box .jg_a li .c7:hover {
  background-position: -73px -354px;
}
.jg_box .jg_a li .c8:hover {
  background-position: -73px -413px;
}
.jg_box .jg_a li .c9:hover {
  background-position: -73px -472px;
}

.link_a {
  width: 1230px;
}
.link_a .link_b {
  background-color: #e7e7e7;
  margin: 20px 0;
  padding-top: 10px;
  padding-bottom: 10px;
}
.link_a .link_b {
  text-align: center;
}
.link_a .link_b .link_c {
  padding: 10px;
}

.bottom_box {
  position: relative;
  text-align: center;
  overflow: hidden;
}
.homebottom {
  margin: 30px 0;
  text-align: center;
  display: inline-block;
  position: absolute;
  top: 0px;
  left: 32%;
}

.current {
  background-color: #1c4199;
}

/*banner*/
.bannerwrap {
  width: 661px;
  overflow: hidden;
  height: 338px;
  position: relative;
  margin: 10px 0px;
  top: -1px;
  float: left;
}
.bannerwrap .imgTitle {
  overflow: hidden;
  position: absolute;
  text-align: left;
  width: 661px;
  z-index: 1;
  height: 40px;
  bottom: 50px;
  line-height: 40px;
  *left: 0;
}
.bannerwrap .imgTitle .bg {
  position: absolute;
  z-index: -1;
  height: 180px;
  background: #252525;
  filter: alpha(opacity=60);
  opacity: 0.5;
  width: 100%;
  top: 0;
}
.bannerwrap .imgTitle .txt {
  line-height: 22px;
  padding: 10px;
}
.bannerwrap .imgTitle .t1 {
  background: #495767;
  width: 100%;
  height: 40px;
  line-height: 40px;
  margin-top: 20px;
}
.bannerwrap h2 {
  position: absolute;
  width: 661px;
  height: 40px;
  line-height: 39px;
  font-size: 16px;
  color: #fff;
  bottom: 0;
  padding: 0 85px 0 15px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: left;
  z-index: 100;
}
/* float */
.slide_x {
  position: relative;
  z-index: 0;
  width: 661px;
  background: #fff;
  height: 338px;
  overflow: hidden;
}
.slide_x .box {
  overflow: hidden;
  position: relative;
  width: 661px;
  height: 338px;
}
.slide_x .list {
  overflow: hidden;
  width: 9999px;
  z-index: 1;
}
.slide_x .list li {
  float: left;
  position: relative;
  width: 661px;
}
.slide_x .list img {
  vertical-align: top;
  width: 661px;
  height: 390px;
}
.slide_x .btn {
  overflow: hidden;
  position: absolute;
  bottom: 10px;
  right: 15px;
  z-index: 10;
}
.slide_x .btn li {
  float: left;
  width: 20px;
  height: 15px;
  margin: 0 0 0 10px;
  font-size: 12px;
  font-family: Arial, Helvetica, sans-serif;
  background: #525252;
  color: #fff;
  line-height: 18px;
  border: 1px solid #434343;
  text-align: center;
  cursor: pointer;
}
.slide_x .btn .selected {
  background: #0b7ed1;
  border-color: #0b7ed1;
}
// .slide_x .minus,.slide_x .plus{position:absolute;top:110px; width:30px; height:75px; background:url(../../assets/imgs/slider_bn_bg.png) no-repeat 0 0; text-align:center;cursor:pointer;}
.slide_x .minus,
.slide_x .plus {
  position: absolute;
  top: 110px;
  width: 30px;
  height: 75px;
  text-align: center;
  cursor: pointer;
}
.slide_x .minus {
  left: 0;
  background-position: 0 0;
}
.slide_x .plus {
  right: 0;
  background-position: 0px -75px;
}
.slide_x .minus:hover {
  background-position: -30px 0px;
}
.slide_x .plus:hover {
  background-position: -30px -75px;
}

#login-form a {
  font-family: "ËÎÌå";
  font-size: 12px;
  color: #ff5336;
  text-decoration: none;
  font-weight: bold;
}

/* 浮动工具条*/
// .izl-rmenu{position:fixed;right:0;bottom:10px;padding-bottom:73px;background:url(../../assets/imgs/r_b.png) 0px bottom no-repeat;z-index:999;}
.izl-rmenu {
  position: fixed;
  right: 0;
  bottom: 10px;
  padding-bottom: 73px;
  z-index: 999;
}
.izl-rmenu .btn {
  width: 72px;
  height: 73px;
  margin-bottom: 1px;
  cursor: pointer;
  position: relative;
}
.izl-rmenu .btn-wx {
  background: url(../../assets/imgs/r_wx.png) 0px 0px no-repeat;
  background-color: #78c340;
}
.izl-rmenu .btn-wx:hover {
  background-color: #58a81c;
}
.izl-rmenu .btn-wx .pic {
  position: absolute;
  left: -160px;
  top: 0px;
  width: 160px;
  height: 160px;
  display: none;
}
.izl-rmenu .btn-phone {
  background: url(../../assets/imgs/r_phone.png) 0px 0px no-repeat;
  background-color: #fbb01f;
}
.izl-rmenu .btn-phone:hover {
  background-color: #ff811b;
}
.izl-rmenu .btn-phone .phone {
  background-color: #ff811b;
  position: absolute;
  width: 160px;
  left: -160px;
  top: 0px;
  line-height: 73px;
  color: #fff;
  font-size: 18px;
  text-align: center;
}

.izl-rmenu .btn-xs {
  background: url(../../assets/imgs/r_xs.png) 0px 0px no-repeat;
  background-color: #6cafeb;
}
.izl-rmenu .btn-xs:hover {
  background-color: #5d9fdb;
}
.izl-rmenu .btn-xs .xs {
  background-color: #5d9fdb;
  position: absolute;
  width: 160px;
  left: -160px;
  top: 0px;
  line-height: 73px;
  color: #fff;
  font-size: 18px;
  text-align: center;
}

.izl-rmenu .btn-mail {
  background: url(../../assets/imgs/r_mail.png) 0px 0px no-repeat;
  background-color: #e37677;
}
.izl-rmenu .btn-mail:hover {
  background-color: #dd6364;
}
.izl-rmenu .btn-mail .mail {
  background-color: #dd6364;
  position: absolute;
  width: 160px;
  left: -160px;
  top: 0px;
  line-height: 73px;
  color: #fff;
  font-size: 15px;
  text-align: center;
}

.izl-rmenu .btn-top {
  background: url(../../assets/imgs/r_top.png) 0px 0px no-repeat;
  background-color: #666666;
  // display: none;
}
.izl-rmenu .btn-top:hover {
  background-color: #444;
}

.pagingsite {
  margin-right: 10px;
  padding-top: 10px;
}
.pagingsite {
  clear: both;
  margin-top: 10px;
  margin-bottom: 10px;
  line-height: normal;
  height: 1%;
  overflow: hidden;
}

//.mianbox .menu_2{ background:url(../../assets/imgs/a2.gif) no-repeat center; height:30px; width:240px; }
.mianbox .menu_2 {
  height: 30px;
  width: 240px;
}

// channel.css

.mianbox .pub_left {
  position: relative;
  font-family: "Microsoft Yahei", "微软雅黑", "宋体", Tahoma, Arial, Helvetica,
    STHeiti;
  float: left;
  width: 305px;
  text-align: center;
  background: url(../../assets/imgs/img_bj.gif) repeat-y top;
  height: 1350px;
}

.mianbox .pub_left .h1_a {
  width: 305px;
  height: 45px;
  background: url(../../assets/imgs/img_bj2.gif) no-repeat top;
  height: 161px;
  font-size: 18px;
  line-height: 38px;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 100%;
  font-weight: 500;
}

/deep/.pub_right {
  float: right;
  width: 870px;
}
.pub_right .pub_content .list {
  padding-bottom: 20px;
}
.pub_right .pub_content .list li .extra {
  font-size: 13px;
  margin: 5px 0px;
  text-align: left;
}
.pub_right .pub_content .list a {
  font-size: 16px;
  text-decoration: none;
  float: left;
}
.pub_right .pub_content .list a span {
  color: #1c4199;
  padding-bottom: 8px;
  display: block;
  float: left;
}
.pub_right .pub_content .list li .extra li {
  display: inline;
  color: #666;
  margin-right: 20px;
}
.pub_right .pub_content .list li .extra .author {
  margin: 0px 5px;
  color: #9b1111;
}
.pub_right .location1 {
  background: #ebebeb url(../../assets/imgs/icon_li.png) no-repeat scroll 18px;
  font-size: 15px;
  line-height: 30px;
  padding-left: 30px;
  padding-top: 2px;
}
.pub_right .pub_content {
  font-size: 14px;
  padding: 15px 0;
  border-bottom: #ccc 1px dotted;
}
.de-date {
  float: right;
}
.de-date a {
  color: #333;
  font-size: 16px;
  padding: 0 5px;
}
.de-date a:hover {
  color: #c00;
}
.disabled {
  color: #cecac5;
}

.pub_right .location {
  color: #333;
}

.ultext {
  padding-top: 20px;
  font-family: "Microsoft Yahei", "微软雅黑", "宋体", Tahoma, Arial, Helvetica,
    STHeiti;
  // padding: 0 10px;
}
.summaryultext {
  padding: 0 10px;
}
.ultext li .sub {
  float: left;
  width: 700px;
  height: 33px;
  text-align: left;
  color: #1c4199;
  font-size: 16px;
}
.ultext li .date {
  float: right;
  height: 23px;
  color: #808080;
  font-size: 12px;
}

/*给国别页法规设置*/
.ultext li .sub1 {
  float: left;
  width: 500px;
  height: 33px;
  text-align: left;
  color: #1c4199;
  font-size: 16px;
  padding-left: 10px;
  padding-top: 10px;
}
.ultext li .date1 {
  float: right;
  height: 23px;
  color: #808080;
  font-size: 12px;
  padding-right: 10px;
  padding-top: 10px;
}

.position {
  background: #ebebeb url(../../assets/imgs/icon_li.png) no-repeat scroll 18px;
  font-size: 15px;
  line-height: 30px;
  padding-left: 30px;
  padding-top: 2px;
}
.pub_left1 {
  position: relative;
  font-family: "Microsoft Yahei", "微软雅黑", "宋体", Tahoma, Arial, Helvetica,
    STHeiti;
  float: left;
  width: 738px;
}

.pub_left2 {
  position: relative;
  font-family: "Microsoft Yahei", "微软雅黑", "宋体", Tahoma, Arial, Helvetica,
    STHeiti;
  float: left;
  width: 810px;
}
.pub_left2 .left-gj {
  margin-top: 15px;
}
.pub_left2 .left-gj .letter {
  text-align: left;
  width: 810px;
  z-index: 100;
  height: 50px;
}
.pub_left2 .left-gj .letter ul li {
  float: left;
  line-height: 50px;
  width: 38px;
  *width: 21px;
}
.pub_left2 .left-gj .letter .card {
  background: url(../../assets/imgs/tu7.gif) no-repeat bottom;
  position: relative;
  height: 14px;
  width: 16px;
  clear: both;
  bottom: 13px;
  *bottom: 12px;
  padding-left: 60px;
}
.pub_left2 .left-gj .letter a {
  padding-left: 23px;
  font-size: 17px;
  color: #333;
}
.pub_left2 .left-gj .letter a:hover {
  color: #c33;
}

.pub_left2 .left-gj .gq {
  // height: 100px;
  height: 215px;
  width: 100%;
  border: #c4dcf1 2px solid;
  margin-bottom: 15px;
}
.pub_left2 .left-gj .ss {
  border: #c4dcf1 2px solid;
  padding: 10px;
}
.pub_left2 .left-gj .ss a {
  color: #333;
  font-weight: bold;
  font-size: 15px;
  width: 100px;
  height: 30px;
  line-height: 35px;
  padding: 23px;
}
.pub_left2 .left-gj .ss a:hover {
  color: #c00;
}
.pub_left2 .left-gj .gq img {
  border: #ebebeb 1px solid;
}
.pub_left2 .left-gj .gq ul {
  margin: 15px;
}
.pub_left2 .left-gj .gq li {
  float: left;
  display: inline;
  width: 157px;
  padding-bottom: 20px;
  text-align: left;
  margin-left: 15px;
}
.pub_left2 .left-gj .gq li a {
  color: #333;
  font-size: 15px;
  font-weight: bold;
}
.pub_left2 .left-gj .gq li a:hover {
  color: #c00;
}

.Country .name {
  text-align: left;
  margin-top: 20px;
  width: 100%;
  border-bottom: 2px #555555 solid;
  margin-bottom: 20px;
}
.Country .name .name_z {
  font-size: 23px;
  font-weight: bold;
}
.Country .name .name_d {
  font-size: 32px;
  margin-left: 5px;
  color: #888b8e;
}
.Country .name .name_s {
  font-size: 23px;
  color: #a9aaac;
}
.Country .name img {
  margin-right: 10px;
  margin-bottom: 8px;
}
.Country .tp_left {
  float: left;
  margin-right: 20px;
  text-align: left;
  width: 220px;
}
.Country .js_right1 {
  width: 100%;
  float: right;
}
.Country .js_right1 p {
  color: #727272;
  line-height: 24px;
  font-size: 14px;
}
.Country .js_right {
  width: 490px;
  float: right;
}
.Country .js_right p {
  color: #727272;
  line-height: 24px;
  font-size: 14px;
}
.Country .js_right2 {
  margin: 10px 0px;
}
.Country .js_right2 li {
  float: left;
  padding: 5px;
  font-size: 15px;
}
.Country .js_right2 li a {
  color: #012f9e;
}
.Country .js_right2 li a:hover {
  color: #c00;
  text-decoration: none;
}

.morebt {
  overflow: hidden;
  _zoom: 1;
  padding: 20px 0 0 0;
}
.morebt ul li {
  float: left;
  margin-right: 8px;
  cursor: pointer;
  line-height: 35px;
  height: 35px;
}
.morebt ul li a {
  text-align: center;
  display: block;
  padding: 0 15px;
}

.morebt1 {
  margin-top: 30px;
  overflow: hidden;
  _zoom: 1;
}
.morebt1 ul li {
  float: left;
  margin-right: 8px;
  cursor: pointer;
  line-height: 35px;
  height: 35px;
}
.morebt1 ul li a {
  text-align: center;
  display: block;
  padding: 0 15px;
}

.tab0 {
  background: #fff url(../../assets/imgs/bgnav.jpg) repeat-x;
  font-weight: 700;
  overflow: hidden;
  border: 1px #1573b4 solid;
  border-bottom: none;
  position: relative;
  bottom: -1px;
  font-size: 14px;
  color: #fff;
}
.tab1 {
  background: #f4fbff url(../../assets/imgs/bg_nav2.jpg) repeat-x bottom;
  border: 1px #bed9f0 solid;
  border-bottom: none;
  font-size: 14px;
  color: #0561a2;
  height: 32px;
  overflow: hidden;
}
.card_b .main1 {
  border: #c2dbf2 1px solid;
  border-top: 2px #c2dbf2 solid;
  min-height: 850px;
}
.card_b .main1 .pub_content {
  padding: 20px;
  *padding: 0;
  *margin: 20px;
}
.card_b .main1 .extra li {
  font-size: 13px;
  float: left;
  padding-right: 10px;
  color: #333;
  line-height: 22px;
}
.card_b .main1 .list a {
  color: #1c4199;
  font-size: 16px;
}

.pub_right1 {
  width: 367px;
  float: right;
  margin-top: 20px;
  z-index: 1000;
}
.pub_right1 .pub_wz {
  padding: 10px 30px 10px 30px;
}
.pub_right1 .pub_wz a {
  color: #1c4199;
  font-size: 16px;
}
.pub_right1 .pub_wz a:hover {
  color: #c00;
}
.pub_right1 .pub_wz .date1 {
  float: right;
  font-size: 12px;
  color: #666;
}
.pub_right1 .pub_wz p {
  margin-top: 5px;
}

.countryP {
  text-indent: 2em;
}

.zdbg {
  background: #ebebeb none repeat scroll 0% 0%;
  height: 1285px;
}

.zdbg li {
  margin-top: 10px;
}

/*---------项目---------------*/

.box_border {
  border: 1px solid #d3dbde;
  margin: 10px;
  *margin: 0px 10px 0 10px;
}
.box_top {
  height: 37px;
  line-height: 37px;
  background: url("../../assets/imgs/box_top.png") 0px 0px repeat-x;
  text-align: center;
}
.box_top_l,
.box_top_r {
  height: 37px;
  line-height: 37px;
}

/*table*/
.list_table {
  width: 100%;
  border-top: 1px solid #d3dbde;
  border-right: 1px solid #d3dbde;
  background: url(../../assets/imgs/map.png) no-repeat center;
  width: 810px;
}
.list_table_head {
  width: 811px;
  border-top: 1px solid #d3dbde;
  border-bottom: 1px solid #d3dbde;
  border-left: 1px solid #d3dbde;
  background-color: #f5f5f5;
}

.list_table_head th {
  height: 37px;
  line-height: 37px;
  border-right: 1px solid #d3dbde;
  font-size: 15px;
}

.list_table th {
  height: 37px;
  background: url("../../assets/imgs/box_top.png") 0px 0px repeat-x;
  line-height: 37px;
  border-left: 1px solid #d3dbde;
  font-size: 15px;
}
.list_table td {
  border-bottom: 1px solid #d3dbde;
  border-left: 1px solid #d3dbde;
  padding: 5px 5px 5px 10px;
  text-align: left;
}
.list_table td a {
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.list_table td a:hover {
  color: #c00;
}
.form_table td {
  padding: 5px 5px;
}

.td_left {
  text-align: left;
}
.td_right {
  text-align: right;
}
.td_right,
.td_center,
.td_left {
  width: 120px;
  line-height: 21px;
}
/*下拉框美化*/
.select {
  width: 243px;
  border: 1px solid #bac7d2;
  padding: 4px 3px;
  font-size: 12px;
  height: 30px;
  *margin: -1px;
  border-radius: 2px;
  box-shadow: 2px 2px 2px #e7f1f7 inset;
  margin: 7px 0px;
}
.select_border {
  height: 29px;
  *background: #fff;
  background: #fff;
  *border: 1px solid #bac7d2;
  *padding: 4px;
  *height: 20px;
}
.select_containers {
  *border: 0;
  *position: relative;
  *height: 18px;
  *overflow: hidden;
}
.select_border,
.select_containers {
  display: inline-block;
}
.ext_btn {
  background: url(../../assets/imgs/button.png) no-repeat center;
  width: 243px;
  height: 32px;
  border: none;
  font-size: 16px;
  color: #fff;
  margin-top: 15px;
  line-height: 8px;
}

.ext_btn:hover {
  background: url(../../assets/imgs/button2.png) no-repeat center;
  width: 243px;
  height: 32px;
}

/*-----------图表-------------*/
.span3 {
  width: 400px;
}
.pr10 {
  padding: 13px;
}
.pl10 {
  padding-left: 10px;
}
.box_center {
  padding: 6px;
}
.box_border .miaoshu {
  color: #333;
  background: #eee;
  height: 60px;
  line-height: 25px;
  padding-left: 10px;
}
.tubiaoli {
  width: 50%;
  float: left;
}

.mr10 {
  margin-right: 10px;
  margin-bottom: 3px;
  float: left;
  margin-top: 5px;
}
.mr5 {
  margin-right: 5px;
}

.pad {
  margin-bottom: 10px;
}

//自己写的样式
//左侧导航
.el-submenu__title {
  height: 40px !important;
}
// .el-menu-vertical-demo li {
//   height: 40px;
// }

.el-menu-vertical-demo li i {
  font-size: 20px;
}

.el-submenu__title a {
  font-size: 16px;
  color: #193d8a;
  padding-left: 60px;
}
.el-submenu__title i {
  font-size: 16px;
}

.pub_left .h1_a ul {
  width: 292px;
  padding: 0 0px 25px 0px;
  text-align: center;
  background-color: #ebebeb;
}

.pub_left .h1_a ul li {
  position: relative;
  margin-bottom: 10px;
  line-height: 40px;
  font-size: 16px;
  margin-right: 10px;
  text-align: left;
  width: 291px;
}

.el-menu .el-submenu__title {
  font-size: 15px !important;
  height: 40px;
  line-height: 45px;
  overflow: hidden;
  padding: 0px;
  padding-left: 0px !important;
  margin: 0 20px;
}

.pub_left .h1_a ul li div:hover {
  background-color: #fff;
  text-decoration: underline;
}
.el-menu-item .el-submenu__title {
  background-color: red;
}

.pubright {
  float: left;
  width: 610px;
  margin-left: 15px;
}
//location导航
.el-breadcrumb {
  font-size: 15px;
  line-height: 30px;
  margin-left: 20px;
}

//分页
.el-pagination {
  font-weight: normal;
}
//项目栏目-搜索框
.elselect {
  width: 250px;
  margin-top: 10px;
}
.eloption {
  margin-left: 15px;
}

/*--------------------------------------园区-----------------------------------*/

.pub_right2 .location {
  color: #333;
}
.location1 .location {
  color: #333;
}

.pub_right2 {
  float: left;
  width: 610px;
  margin-left: 15px;
}
.pub_right2 .pub_content .list {
  padding: 0 15px 20px 15px;
}
.pub_right2 .abstract {
  line-height: 25px;
  font-size: 14px;
}
.pub_right2 .pub_content .list li .extra {
  font-size: 13px;
  margin: 5px 0px;
}
.pub_right2 .pub_content .list a {
  font-size: 16px;
  text-decoration: none;
  float: left;
}
.pub_right2 .pub_content .list a span {
  color: #1c4199;
}
.pub_right2 .pub_content .list li .extra li {
  float: left;
  color: #666;
  margin-right: 20px;
}
.pub_right2 .pub_content .list li .extra .author {
  margin: 0px 5px;
  color: #9b1111;
}
.pub_right2 .pub_content {
  margin-top: 28px;
  font-size: 14px;
  border-bottom: #ccc 1px dotted;
}

.boxright3 {
  width: 240px;
}

.mianbox .map .icon1 {
  position: absolute;
  font-size: 13px;
  left: 650px;
  top: 30px;
}
.mianbox .map .icon2 {
  position: absolute;
  font-size: 13px;
  left: 755px;
  top: 350px;
}
.mianbox .map .icon3 {
  position: absolute;
  font-size: 13px;
  left: 760px;
  top: 285px;
}
.mianbox .map .icon4 {
  position: absolute;
  font-size: 13px;
  left: 720px;
  top: 310px;
}
.mianbox .map .icon5 {
  position: absolute;
  font-size: 13px;
  left: 520px;
  top: 235px;
}
.mianbox .map .icon6 {
  position: absolute;
  font-size: 13px;
  left: 270px;
  top: 260px;
}
.mianbox .map .icon7 {
  position: absolute;
  font-size: 13px;
  left: 210px;
  top: 80px;
}
.mianbox .map .icon8 {
  position: absolute;
  font-size: 13px;
  left: 770px;
  top: 325px;
}
.mianbox .map .icon9 {
  position: absolute;
  font-size: 13px;
  left: 280px;
  top: 60px;
}
.mianbox .map .icon10 {
  position: absolute;
  font-size: 13px;
  left: 560px;
  top: 140px;
}
.mianbox .map .icon11 {
  position: absolute;
  font-size: 13px;
  left: 940px;
  top: 290px;
}
.mianbox .map .icon12 {
  position: absolute;
  font-size: 13px;
  left: 270px;
  top: 20px;
}
.mianbox .map .icon13 {
  position: absolute;
  font-size: 13px;
  left: 740px;
  top: 390px;
}
.mianbox .map .icon14 {
  position: absolute;
  font-size: 13px;
  left: 225px;
  top: 125px;
}
.mianbox .map .icon15 {
  position: absolute;
  font-size: 13px;
  left: 450px;
  top: 300px;
}
.mianbox .map .icon16 {
  position: absolute;
  font-size: 13px;
  left: 360px;
  top: 270px;
}
.mianbox .map .icon17 {
  position: absolute;
  font-size: 13px;
  left: 250px;
  top: 100px;
}
.mianbox .map .icon18 {
  position: absolute;
  font-size: 13px;
  left: 1050px;
  top: 333px;
}
.mianbox .map .icon19 {
  position: absolute;
  font-size: 13px;
  left: 590px;
  top: 290px;
}
.mianbox .map .icon20 {
  position: absolute;
  font-size: 13px;
  left: 500px;
  top: 80px;
}

.mianbox .map ul {
  background: #fff;
  padding: 10px;
  border: 1px solid #2b66af;
  z-index: 300;
  position: relative;
  max-height: 300px;
  overflow: auto;
  width: 260px;
  white-space: nowrap;
}
.mianbox .map a {
  z-index: 100;
  position: relative;
}

.pub_content p {
  font-size: 14px;
  line-height: 25px;
  // height:47px;
  // overflow: hidden;
}
.pub_wz p {
  font-size: 14px;
  line-height: 25px;
}

/*右侧菜单新增样式2016-12-28*/
.morebt2 {
  margin-top: 10px;
  overflow: hidden;
  _zoom: 1;
  border-bottom: 2px solid #1573b4;
}
.morebt2 ul li {
  float: left;
  margin-right: 8px;
  cursor: pointer;
  line-height: 30px;
  height: 30px;
}
.morebt2 ul li a {
  text-align: center;
  display: block;
  padding: 0 15px;
}

/*--------------------------------------园区-----------------------------------*/

.pub_right2 .location {
  color: #333;
}
.location1 .location {
  color: #333;
}

.pub_right2 {
  float: left;
  width: 610px;
  margin-left: 15px;
}
.pub_right2 .pub_content .list {
  padding: 0 15px 20px 15px;
}
.pub_right2 .abstract {
  line-height: 25px;
  font-size: 14px;
}
.pub_right2 .pub_content .list li .extra {
  font-size: 13px;
  margin: 5px 0px;
}
.pub_right2 .pub_content .list a {
  font-size: 16px;
  text-decoration: none;
  float: left;
}
.pub_right2 .pub_content .list a span {
  color: #1c4199;
}
.pub_right2 .pub_content .list li .extra li {
  float: left;
  color: #666;
  margin-right: 20px;
}
.pub_right2 .pub_content .list li .extra .author {
  margin: 0px 5px;
  color: #9b1111;
}
.pub_right2 .pub_content {
  margin-top: 28px;
  font-size: 14px;
  border-bottom: #ccc 1px dotted;
}

.boxright3 {
  width: 240px;
}
/*background-color:#F1F1F1; height:1300px; overflow:auto; white-space:nowrap*/
.right3 ul li a {
  color: #403f3f;
  font-family: "微软雅黑", "Microsoft YaHei";
}
.right3 ul li a:hover {
  color: #5b9fe3;
}
.right3 ul li {
  line-height: 32px;
  float: left;
  font-size: 14px;
  width: 220px;
  text-align: left;
  list-style-type: disc;
}

.right3 ul {
  padding-left: 15px;
  padding-top: 1px;

  overflow: hidden;
  background: #f0f0f0;
  color: #403f3f;
  width: 240px;
}

.mianbox .map .icon1 {
  position: absolute;
  font-size: 13px;
  left: 650px;
  top: 30px;
}
.mianbox .map .icon2 {
  position: absolute;
  font-size: 13px;
  left: 755px;
  top: 350px;
}
.mianbox .map .icon3 {
  position: absolute;
  font-size: 13px;
  left: 760px;
  top: 285px;
}
.mianbox .map .icon4 {
  position: absolute;
  font-size: 13px;
  left: 720px;
  top: 310px;
}
.mianbox .map .icon5 {
  position: absolute;
  font-size: 13px;
  left: 520px;
  top: 235px;
}
.mianbox .map .icon6 {
  position: absolute;
  font-size: 13px;
  left: 270px;
  top: 260px;
}
.mianbox .map .icon7 {
  position: absolute;
  font-size: 13px;
  left: 210px;
  top: 80px;
}
.mianbox .map .icon8 {
  position: absolute;
  font-size: 13px;
  left: 770px;
  top: 325px;
}
.mianbox .map .icon9 {
  position: absolute;
  font-size: 13px;
  left: 280px;
  top: 60px;
}
.mianbox .map .icon10 {
  position: absolute;
  font-size: 13px;
  left: 560px;
  top: 140px;
}
.mianbox .map .icon11 {
  position: absolute;
  font-size: 13px;
  left: 940px;
  top: 290px;
}
.mianbox .map .icon12 {
  position: absolute;
  font-size: 13px;
  left: 270px;
  top: 20px;
}
.mianbox .map .icon13 {
  position: absolute;
  font-size: 13px;
  left: 740px;
  top: 390px;
}
.mianbox .map .icon14 {
  position: absolute;
  font-size: 13px;
  left: 225px;
  top: 125px;
}
.mianbox .map .icon15 {
  position: absolute;
  font-size: 13px;
  left: 450px;
  top: 300px;
}
.mianbox .map .icon16 {
  position: absolute;
  font-size: 13px;
  left: 360px;
  top: 270px;
}
.mianbox .map .icon17 {
  position: absolute;
  font-size: 13px;
  left: 250px;
  top: 100px;
}
.mianbox .map .icon18 {
  position: absolute;
  font-size: 13px;
  left: 1050px;
  top: 333px;
}
.mianbox .map .icon19 {
  position: absolute;
  font-size: 13px;
  left: 590px;
  top: 290px;
}
.mianbox .map .icon20 {
  position: absolute;
  font-size: 13px;
  left: 500px;
  top: 80px;
}

.mianbox .map ul {
  background: #fff;
  padding: 10px;
  border: 1px solid #2b66af;
  z-index: 300;
  position: relative;
  max-height: 300px;
  overflow: auto;
  width: 260px;
  white-space: nowrap;
}
.mianbox .map a {
  z-index: 100;
  position: relative;
}

.pub_content p {
  font-size: 14px;
  line-height: 25px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.pub_wz p {
  font-size: 14px;
  line-height: 25px;
}

/*右侧菜单新增样式2016-12-28*/
.morebt2 {
  margin-top: 10px;
  overflow: hidden;
  _zoom: 1;
  border-bottom: 2px solid #1573b4;
}
.morebt2 ul li {
  float: left;
  margin-right: 8px;
  cursor: pointer;
  line-height: 30px;
  height: 30px;
}
.morebt2 ul li a {
  text-align: center;
  display: block;
  padding: 0 15px;
}
.boxright3 .right3 .yqlist {
  background-color: #f7f7f7;
  height: 1000px;
  overflow: auto;
  // white-space: nowrap;
  padding: 10px 0 0 0px;
  margin-top: 5px;
}

// 面包屑样式
.el-breadcrumb__inner a,
.el-breadcrumb__inner.is-link {
  font-weight: normal;
}
.el-breadcrumb__inner .is-link {
  font-weight: normal;
}

.el-submenu__title * {
  vertical-align: inherit;
}

.el-menu-item,
.el-submenu__title {
  height: 40px;
  line-height: 40px;
}

.el-menu-item a {
  font-size: 16px;
  color: #193d8a;
  padding-left: 60px;
}

.el-menu-item {
  background-color: #fff;
}
/deep/.is-active {
  background-color: #185bb0;
}

.or {
  color: #fff;
}

.pub_left .h1_a ul div li:hover {
  background-color: none;
}

/deep/.is-active a {
  color: #fff;
}

.router-link-exact-active .router-link-active .or {
  background-color: #185bb0;
  color: #fff;
}

.el-menu--inline li {
  background-color: #ebebeb;
}
// 园区目录父
.parentli {
  cursor: pointer;
  background: #f7f7f7;
  color: #060809;
  font-family: 微软雅黑, Microsoft YaHei;
  padding: 0px 0 0 20px;
}
.parentspan {
  float: right;
}
// 园区目录子
.sonul {
  display: none;
}
.sonimg {
  margin-left: 18px;
}
</style>